import { FC } from "react";
import { Box, Group, Select } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Logo } from "../../../shared/svg";
import "./Header.scss";
import { MenuIcon } from "../../../shared/svg/MenuIcon";
import { useTranslation } from "react-i18next";
import useProfileStore from "../../../store/useProfileStore";
import useAuthStore from "../../../store/useAuthStore";
import { setProfileLanguage } from "../../../api/profileApi";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MainHeader: FC<Props> = ({ setOpen }) => {
  const { t, i18n } = useTranslation();

  const { getProfileLanguage } = useProfileStore();
  const { access_token } = useAuthStore();

  const handleLanguageChange = async (value: string | null) => {
    if (value) {
      i18n.changeLanguage(value);
      if (access_token) {
        await setProfileLanguage(value);
        await getProfileLanguage();
      }
    }
  };

  const matches = useMediaQuery("(max-width: 670px)");

  return (
    <Group
      justify="space-between"
      align="center"
      className="header"
      px="24px"
      py="md"
      pl="xs"
    >
      <Logo width={190} height={40} />
      {matches ? (
        <Box
          className="pointer"
          onClick={() => setOpen((prevOpen) => !prevOpen)}
        >
          <MenuIcon />
        </Box>
      ) : (
        <Group>
          <Select
            value={i18n.language}
            onChange={handleLanguageChange}
            data={[
              { value: "en", label: t("english") },
              { value: "uk", label: t("ukrainian") },
            ]}
            style={{ width: 150 }}
          />

          {/* <Button variant="outline">{t("upgrade")}</Button>
          <Button>{t("book_coaching")}</Button> */}
        </Group>
      )}
    </Group>
  );
};
